module.exports = __webpack_public_path__ + "static/11-787c842e40fb9da893697dcd95148d62.png";